import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';

import { IncomingTransactionList } from './_authenticated._main.invoicing.transactions/IncomingTransactionList';
import { TransactionList } from './_authenticated._main.invoicing.transactions/TransactionList';
import { Spinner } from '../components/Spinner';
import { Tab, Tabs } from '../components/Tab';
import { useFetchNetGains } from '../hooks/useFetchNetGains';
import { t } from '../services/translation/translation';
import { formatPrice } from '../utils/price';

type InvoiceTab = 'pending' | 'paid';

const TAB_SEARCH_PARAM_KEY = 'tab';

const tabs: Tab<InvoiceTab>[] = [
  { id: 'pending', label: t('common.toPay') },
  { id: 'paid', label: t('common.paid') },
];

export const TransactionsRoute = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTabKey = (searchParams.get(TAB_SEARCH_PARAM_KEY) as InvoiceTab) ?? 'pending';
  // const paymentStatus = activeTabKey === 'paid' ? 'PAID' : activeTabKey === 'pending' ? 'PENDING' : undefined;
  const { data: dataNetGains, isLoading: isLoadingNetGains } = useFetchNetGains();
  const { data: dataPending, isLoading: isLoadingPending } = useFetchNetGains({ paymentStatus: 'PENDING' });

  return (
    <div>
      <Helmet>
        <title>{t('transactions-route.title')} - Allocab</title>
      </Helmet>

      <h3 className="text-3xl font-bold dark:text-white mb-6">{t('transactions-route.title')}</h3>
      <div className="flex justify-between w-full space-x-4">
        {isLoadingNetGains ? (
          <Spinner />
        ) : (
          <div className="flex-1 p-4 rounded-lg relative">
            <div
              className="absolute inset-0 bg-gradient-to-r from-orange-500 to-orange-300 rounded-lg"
              aria-hidden="true"
            ></div>
            <div className="relative text-white font-bold text-center">
              {dataNetGains ? formatPrice(dataNetGains?.netGain.amount) : undefined}{' '}
              {t('transactions-route.total-from-2025')}
            </div>
          </div>
        )}
        {isLoadingPending ? (
          <Spinner />
        ) : (
          <div className="flex-1 p-4 rounded-lg relative">
            <div
              className="absolute inset-0 bg-gradient-to-r to-gray-600 from-gray-400 rounded-lg"
              aria-hidden="true"
            ></div>
            <div className="relative text-white font-bold text-center">
              {dataPending ? formatPrice(dataPending.netGain.amount) : undefined} {t('transactions-route.remaining')}
            </div>
          </div>
        )}
      </div>

      <div>
        <Tabs
          items={tabs}
          onChange={id => {
            setSearchParams(params => {
              params.set(TAB_SEARCH_PARAM_KEY, id);
              params.delete('page');
              return params;
            });
          }}
          initialTab={activeTabKey}
        />

        {activeTabKey === 'pending' ? <IncomingTransactionList /> : <TransactionList status="VALIDATED" />}
      </div>
    </div>
  );
};
